export default {"src":"/_next/static/media/card-placeholder-1.35ed5e1c.svg","height":162,"width":231,"blurWidth":0,"blurHeight":0};